<template>
  <div>
    <div class="form-group mt-2">
      <label for="PtaFormSize" class="font-weight-bold text-dark d-block">{{ $t('Size:') }}</label>
      <OptionValue v-for="(combination, index) in this.product.combinations"
                    :key="combination.size + '-' + combination.color"
                    v-on:change="combinationIndex = index"
                    :option-value="index"
                    :selected="combinationIndex === index"
                    class="mb-2"
      >
        {{ (!combination.size && !combination.color) ? 'n/a' : ''}}
        {{combination.size}} {{ combination.size && combination.color ? ' - ' : ''}} {{combination.color}}
      </OptionValue>
    </div>

    <div class="form-group mt-4">
      <label for="PtaFormSlot" class="font-weight-bold text-dark d-block">{{ $t('Slot:') }}</label>
      <div v-if="!stage" id="combination-disabled" class="text-muted">
        {{ $t('Select stage first') }}
      </div>
      <div v-else-if="combinationIndex === null" class="text-muted">
        {{ $t('Select size first') }}
      </div>
      <div v-else-if="status === 'fetching-slots'" class="text-muted">
        {{ $t('Retrieving available slots') }}
      </div>
      <div v-else-if="Number.isInteger(combinationIndex)&& stotsAvailable.length === 0" class="text-danger">
        {{ $t('No slots available') }}
      </div>
      <OptionValue v-for="stotAvailable in stotsAvailable"
                   :key="stotAvailable.id"
                   v-on:change="slotId = stotAvailable.id"
                   :option-value="stotAvailable.id"
                   :selected="slotId === stotAvailable.id"
                   :disabled="!stotAvailable.is_available"
                   class="mb-2"
      >
        {{stotAvailable.text}} {{ stotAvailable.is_available ? '' : '(' + $t("not available") + ')' }}
      </OptionValue>
    </div>
  </div>
</template>

<script>
import OptionValue from "@/components/frontend/ui/OptionValue.vue";
import {formatDateRange} from "@/utils/date";

export default {
  name: "SlotAvailability",
  components: {
    OptionValue,
  },
  props: {
    stage: {
      required: true,
    },
    product: {
      required: true,
    },
    urlAvailability: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      status: 'idle',
      combinationIndex: null,
      stotsAvailable: [],
      slotId: null,
    }
  },
  watch : {
    stage: function (stage) {
      this.fetchAvailability();
    },
    combinationIndex: function (index) {
      // console.log('combinationIndex changed', index, this.product.combinations[index])
      this.$emit('combinationChange', {
        color: this.product.combinations[index].color,
        size: this.product.combinations[index].size,
      });
      this.fetchAvailability();
    },
    slotId: function (id) {
      this.$emit('slotChange', id)
    },
    equipment: function (equipment) {
      // console.log('find equipment', equipment)
      this.$emit('findEquipment', equipment)
    },
  },
  computed: {
    combination() {
      return this.product.combinations[this.combinationIndex]
    },
    equipment() {
      if (!this.slotId || !this.combination || !this.slot || this.slot.equipments_available.length === 0) {
        return null;
      }
      return this.slot.equipments_available[0].id
    },
    slot: function () {
      if (!this.slotId) {
        return null;
      }
      return this.stotsAvailable.find(slot => slot.id === parseInt(this.slotId));
    },
  },
  methods: {
    fetchAvailability : async function() {
      // console.log('fetchAvailability', this.combination, this.stage)
      this.stotsAvailable = [];
      if (this.combination && this.stage) {
        this.status = 'fetching-slots';

        try {
          const availabilityResponse = await axios.get(this.urlAvailability, {
            params: {
              product: this.product.id,
              stage: this.stage.id,
              size: this.combination.size,
              color: this.combination.color
            }
          })

          this.stotsAvailable = availabilityResponse.data.data.map((slot) => {
            return {
              text: formatDateRange(slot.local_start_at, slot.local_end_at),
              is_available: ! (slot.equipments_available.length === 0),
              ...slot
            }
          });
          if (this.stotsAvailable.length > 0) {
            this.slotId = this.stotsAvailable.filter((slot) => slot.is_available)[0]?.id;
          }

        } catch (error) {
          // alert('Error while fetching slot availability');
          console.log(error);
        }
        this.status = 'idle';
      }
    },
  },
  mounted() {
    if(this.product.combinations.length === 1) {
      this.combinationIndex = 0;
    }
    this.fetchAvailability();
  }
}
</script>

<style scoped>

</style>